import axios from 'axios';

import RequestHeadersBase from '~/common/constants/RequestHeadersBase';
import { handleRefreshInterceptor } from '~/services/interceptors/handle-refresh.interceptor';
import { setAuthTokenInterceptor } from '~/services/interceptors/set-auth-token.interceptor';
import {
  GeoComplyReasonCode,
  GeoComplyTokenType,
  Method,
  setLocationInterceptor,
} from '~/services/interceptors/set-location.interceptor';

export const marketplaceServiceInstance = axios.create({
  baseURL: `${process.env.NEXT_PUBLIC_API_URL_SPLASH}marketplace-service/api`,
  headers: { ...RequestHeadersBase },
});

setAuthTokenInterceptor(marketplaceServiceInstance);
handleRefreshInterceptor(marketplaceServiceInstance);
setLocationInterceptor(marketplaceServiceInstance, [
  [
    Method.POST,
    /^splits\/invites\/[^/]+\/accept$/,
    { reasonCode: GeoComplyReasonCode.PURCHASE_WAGER, tokenType: GeoComplyTokenType.VALID },
  ],
  // Buy-now is a purchase: the backend's assertBuyerEligible reads the forwarded
  // location headers — without this entry every purchase 403s LOCATION_NOT_ALLOWED.
  [
    Method.POST,
    /^listings\/[^/]+\/buy-now$/,
    { reasonCode: GeoComplyReasonCode.PURCHASE_WAGER, tokenType: GeoComplyTokenType.VALID },
  ],
  // Offers escrow the full bid at creation — a purchase for location purposes, same
  // as buy-now.
  [
    Method.POST,
    /^offers$/,
    { reasonCode: GeoComplyReasonCode.PURCHASE_WAGER, tokenType: GeoComplyTokenType.VALID },
  ],
  // Accepting an offer settles it (funds + shares move) — the backend asserts buyer
  // eligibility off the forwarded location headers, same as buy-now.
  [
    Method.PATCH,
    /^offers\/[^/]+\/accept$/,
    { reasonCode: GeoComplyReasonCode.PURCHASE_WAGER, tokenType: GeoComplyTokenType.VALID },
  ],
  // Submitting partner drafts opens an offer per item through the same offer-creation path (each
  // escrows its bid), so the backend reads the forwarded location headers — without this entry every
  // partner submit 403s LOCATION_NOT_ALLOWED.
  [
    Method.POST,
    /^partner\/offers\/submit$/,
    { reasonCode: GeoComplyReasonCode.PURCHASE_WAGER, tokenType: GeoComplyTokenType.VALID },
  ],
]);
